import { Link } from '@tanstack/react-router'

export const IndexPage = (): React.ReactNode => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Link to='/driver-recharge'>Driver Recharge</Link>
            <Link to='/driver-recharge/success'>Driver Recharge Success</Link>
            <Link to='/driver-recharge/error'>Driver Recharge Error</Link>
            <Link to='/pass-card-bind'>Pass Card Bind</Link>
            <Link to='/pass-card-bind/success'>Pass Card Bind Success</Link>
            <Link to='/pass-card-bind/error'>Pass Card Bind Error</Link>
            <Link to='/withdrawal'>Withdrawal</Link>
            <Link to='/withdrawal-smz'>Withdrawal SMZ</Link>
            <Link to='/withdrawal-smz/account-link'>Withdrawal SMZ/Account Link</Link>
            <Link to='/withdrawal-smz/form'>SMZ Form</Link>
            <Link to='/redirect'>Redirect</Link>
        </div>
    )
}
